import { render, staticRenderFns } from "./ReferralsDropdownPanel.vue?vue&type=template&id=0942f4a9&scoped=true&"
import script from "./ReferralsDropdownPanel.vue?vue&type=script&lang=js&"
export * from "./ReferralsDropdownPanel.vue?vue&type=script&lang=js&"
import style0 from "./ReferralsDropdownPanel.vue?vue&type=style&index=0&id=0942f4a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0942f4a9",
  null
  
)

export default component.exports